<template>
  <div id="app">
    <Header />
    <main class="main">
      <router-view />
    </main>
    <Footer />
    <ConnectPopup />
  </div>
</template>

<style lang="scss">
</style>
<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import ConnectPopup from "./components/ConnectPopup";
import { mapGetters } from "vuex";

export default {
  components: { ConnectPopup, Footer, Header },
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account"]),
  },
  async created() {
    // await this.$store.dispatch("bootstrap");
  },
  async mounted() {
    localStorage.clear();
  }
};
</script>
